// extracted by mini-css-extract-plugin
module.exports = {"base":"base--C06BsT","nowrap":"nowrap--YOngtI","center":"center--ZJvEmc"};